/**
 * Hook de acceso al contexto de autenticación.
 *
 * Devuelve la sesión (`user`, permisos, sede activa) y las acciones (`logout`,
 * `setActiveSede`). Exige estar dentro del `AuthProvider`: si no, lanza, en vez
 * de devolver un estado silenciosamente vacío.
 */
import { useContext } from "react";

import { AuthContext, type AuthContextValue } from "./AuthContext";

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error("useAuth debe usarse dentro de <AuthProvider>.");
  }
  return context;
}
